import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import ProgressBar from '../ProgressBar';
import { isMatrixOpenEndedFamily, transformPrompt } from '../../utils';
import { getQuestionPrompt, isEmptyPrompt } from './utils';

export default function QuestionPrompt({ question }) {
  const { getText } = Pollfish.ui;
  const questionPrompt = useMemo(() => getQuestionPrompt(question, getText), [
    question,
    getText,
  ]);

  const { htmlPrompt, style } = question;
  let { prompt } = question;
  const isMatrixOpenEnded = isMatrixOpenEndedFamily(style);
  const forExample = getText('eg') || 'e.g.';
  if (question.f_name === 'dg_year_of_birth') {
    prompt = `${prompt} (${forExample} 1984)`;
  }

  if (!isEmpty(htmlPrompt)) {
    prompt = htmlPrompt;
  }

  prompt = transformPrompt(prompt);

  // if question is matrix open ended and question prompt is empty
  // we do not want to occupy space
  let promptClassName = 'js-question question__text';
  if (isMatrixOpenEnded && isEmptyPrompt(prompt)) {
    promptClassName = 'js-question';
  }

  return (
    <div className="question-wrapper">
      <div className="question">
        <ProgressBar />
        <div
          className={promptClassName}
          id={question.id}
          data-ref-id={question.refId || ''}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: prompt }}
        />
        <div className="question__prompt-wrapper">
          <div className="question__prompt">{questionPrompt}</div>
        </div>
      </div>
    </div>
  );
}

QuestionPrompt.propTypes = {
  question: PropTypes.object,
};
